import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Grid } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import participantsApi from '../../../services/api/participants/participantsApi';
import { authConfig } from '../../../config/auth';
import paths from '../../../routes/paths';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { iconGoogle } from '../../assets/images';

const GoogleLoginForm = ({ onBackClick }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const { email, name, picture } = decoded;
      const payload = { email, idToken: credentialResponse.credential, provider: 'google' };
      localStorage.setItem('auth_redirect_url', paths.pupilSurveys);
      let authResponse = await participantsApi.verifyStudent(payload);
      if (typeof authResponse === 'string') {
        try { authResponse = JSON.parse(authResponse); } catch {}
      }
      if (authResponse && authResponse.studentId > 0) {
        localStorage.setItem('pupil', JSON.stringify({ ...authResponse, provider: 'google', name, email, picture }));
        window.location.href = paths.pupilSurveys;
      } else {
        setError('Google account not linked to any student profile');
      }
    } catch {
      setError('Google authentication failed');
    }
    setLoading(false);
  };

  const handleError = () => {
    setError('Google authentication failed');
    setLoading(false);
  };

  return (
    <Grid container justifyContent="center">
      <Grid item lg={6} md={6} sm={11} xs={11}>
        <div className="formHeader">
          <div className="iconContainer">
            <img src={iconGoogle} alt="" />
          </div>
          <h2 className="formTitle">
            Login with Google
          </h2>        
        </div>
        <div className="formDescription">
          Sign in with your Google account to access your surveys
        </div>
        {error && (
          <Typography color="error" sx={{ mb: 2 }} textAlign="center">{error}</Typography>
        )}
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <div className="googleLoginButton">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              useOneTap={false}
              width="500"            
              text="continue_with"
              shape="rectangular"
              logo_alignment="left"          
              size='large'
              theme='filled_blue'            
            />
          </div>
        </Box>
        <Button
          fullWidth
          variant="text"
          onClick={onBackClick}
          className="backButton"
          disabled={loading}
          startIcon={<KeyboardBackspaceIcon />} disableRipple
        >
          Back to Login Options
        </Button>
        {loading && <CircularProgress size={24} sx={{ mt: 2 }} />}
      </Grid>
    </Grid>
  );
};

export default GoogleLoginForm;
